import React from 'react';
import Header from '../components/Header';
import IntegrationsSection from '../components/IntegrationsSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const IntegracionesPage = () => {
  const seoData = {
    title: 'Integraciones y Herramientas',
    description: 'Conecta Runamatic con más de 50 herramientas: OpenAI, Google Sheets, Shopify, WooCommerce, Stripe, PayPal, Mailchimp y más. Automatización completa.',
    keywords: 'integraciones runamatic, OpenAI integration, Google Sheets, Shopify, WooCommerce, Stripe, PayPal, Mailchimp, CRM integrations',
    canonical: '/integraciones',
    ogTitle: 'Integraciones y Herramientas - Runamatic',
    ogDescription: 'Más de 50 integraciones disponibles. Conecta con tus herramientas favoritas y automatiza completamente tu negocio.',
    schema: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Integraciones Runamatic",
      "description": "Plataforma de integraciones para automatización de negocios",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "description": "Integraciones incluidas en todos los planes"
      }
    }
  };

  return (
    <>
      <SEO {...seoData} />
      <Header />
      <main>
        <IntegrationsSection />
      </main>
      <Footer />
    </>
  );
};

export default IntegracionesPage; 